import { useIntl } from 'react-intl';
import { getSections } from '~/reducers/intakeForm';
import Box from '~/ui/components/Box/Box';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';
import { hasEnabledFields } from '~/utils/intakeForm';

const SIDEBAR_WIDTH = '280px';

const TicketFormSidebar = ({
  activeSectionId,
  onSidebarSectionClick,
  intakeForm,
}) => {
  const intl = useIntl();
  const sections = getSections(intakeForm)
    .filter((section) => hasEnabledFields(intakeForm, section))
    .sort((a, b) => (a.position ?? 0) - (b.position ?? 0));

  return (
    <>
      <FlexLayout
        flexDirection="column"
        space={6}
        sx={{ position: 'absolute', width: SIDEBAR_WIDTH }}
      >
        <FlexLayout flexDirection="column" space={4}>
          <Text color="gray-600" variant="body2">
            {intl.formatMessage({
              id: 'TicketFormSidebar.sectionsLabel',
              defaultMessage: 'SECTIONS',
              description: 'Label for the sections in the sidebar',
            })}
          </Text>
          <Box>
            {sections.map((section) => {
              const { id: sectionId, name: sectionName } = section;
              const indicatorColor =
                activeSectionId === sectionId ? 'blue-500' : 'blue-100';
              return (
                <FlexLayout
                  alignItems="center"
                  key={sectionId}
                  space={4}
                  onClick={() => onSidebarSectionClick(sectionId)}
                >
                  <Box bg={indicatorColor} py={5} px="2px" />
                  <Text variant="body1" sx={{ wordBreak: 'break-word' }}>
                    {sectionName}
                  </Text>
                </FlexLayout>
              );
            })}
          </Box>
        </FlexLayout>
      </FlexLayout>
      <Box sx={{ width: SIDEBAR_WIDTH, flexShrink: 0 }} />
    </>
  );
};

export { TicketFormSidebar };
